import React from 'react'

const variantClasses = {
    success: {
        wrap: 'border-green-200 bg-green-50 text-green-800',
        dismiss: 'text-green-700 hover:bg-green-100 hover:text-green-900'
    },
    error: {
        wrap: 'border-red-200 bg-red-50 text-red-800',
        dismiss: 'text-red-700 hover:bg-red-100 hover:text-red-900'
    }
}

export default function InlineAlert({ variant, children, onDismiss, className = '' }) {
    const v = variantClasses[variant] ?? variantClasses.error

    return (
        <div
            className={`mb-6 flex items-start justify-between gap-4 rounded-lg border px-4 py-3 text-sm ${v.wrap} ${className}`.trim()}
            role={variant === 'success' ? 'status' : 'alert'}
        >
            <div className="min-w-0"><h2 className="text-lg font-bold">{variant === 'success' ? 'Success' : 'Error'}</h2><p className="pt-5">{children}</p></div>
            {onDismiss && (
                <button
                    type="button"
                    onClick={onDismiss}
                    className={`shrink-0 rounded p-0.5 ${v.dismiss}`}
                    aria-label="Dismiss"
                >
                    ×
                </button>
            )}
        </div>
    )
}
